/**
 * By default, the graphql-ws library sends a GraphQL-specific protocol into the
 * WebSocket conection, which gets sent as a header. Undertow doesn't know what
 * to do with that header and ignores the request entirely. This little hack
 * gets around that issue by not sending up any protocols.
 */

export class ProtocolFreeWebSocket extends WebSocket {
  constructor(url: string, protocols: unknown) {
    super(url, []);
  }
}
